(function () {
  var signup = document.querySelector('[data-beauty-popup-signup]');
  if (!signup) return;

  var form = signup.querySelector('form');
  var field = form && form.querySelector('input[type="email"]');
  var button = form && form.querySelector('button[type="submit"]');
  var message = signup.querySelector('[data-beauty-popup-message]');
  var success = signup.querySelector('[data-beauty-popup-success]');
  var cta = signup.querySelector('[data-beauty-popup-shop]');
  var storageKey = 'nail-garden-danella-seoul-glow-popup-dismissed-v8';
  var busy = false;
  if (!form || !field || !button) return;

  function showMessage(text) {
    if (message) message.textContent = text || '';
  }

  function finish() {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (_error) {
      // Signup still works when browser storage is unavailable.
    }
    signup.setAttribute('data-done', '');
    if (cta) cta.hidden = false;
    if (success) success.focus();
  }

  function fail() {
    busy = false;
    button.disabled = false;
    showMessage('Something went wrong. Please check your email address and try again.');
    field.focus();
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (busy) return;

    if (!field.value || !field.checkValidity()) {
      showMessage('Please enter a valid email address.');
      field.focus();
      return;
    }

    busy = true;
    button.disabled = true;
    showMessage('');

    window.fetch(form.action, {
      method: 'POST',
      body: new window.FormData(form),
      credentials: 'same-origin'
    }).then(function (response) {
      var url = response.url || '';
      if (url.indexOf('/challenge') !== -1) {
        // Shopify asked for a human check; let the browser handle it normally.
        form.submit();
        return;
      }
      if (response.ok && url.indexOf('customer_posted=true') !== -1) {
        finish();
      } else {
        fail();
      }
    }).catch(fail);
  });
})();
